import { Component } from '@angular/core';

@Component( {
    selector: 'psv-person-search-form',
    templateUrl: './person-search-form.component.html'
} )
export class PersonSearchFormComponent { }
